// src/features/business-functions/adapters/workspaceListAdapter.js
import { WORKSPACE_ICON_MAP } from '../constants/accountConstants';
import { CAMPAIGN_COPY } from '../constants/campaignCopy';

/**
 * Transforms a raw backend workspace DTO into a normalized frontend model.
 *
 * @param {object} raw — Single workspace object from API
 * @returns {object} — Normalized workspace model
 */
export function adaptWorkspace(raw) {
  if (!raw) return null;

  const typeKey = raw.type ?? raw.workspace_type ?? 'default';
  const iconConfig = WORKSPACE_ICON_MAP[typeKey] || WORKSPACE_ICON_MAP.default;

  return {
    id: raw.id ?? '',
    name: raw.name ?? raw.workspace_name ?? CAMPAIGN_COPY.untitled,
    description: raw.description ?? '',
    type: typeKey,
    iconName: iconConfig.icon,
    accentKey: iconConfig.colorKey,
    tablesCount: raw.tables_count ?? 0,
    viewsCount: raw.views_count ?? 0,
    automationsCount: raw.automations_count ?? 0,
    isDisabled: Boolean(raw.is_disabled),
  };
}

/**
 * Transforms an array of raw workspace DTOs into normalized frontend models.
 *
 * @param {Array} rawList — Array of workspace objects from API
 * @returns {Array} — Array of normalized workspace models
 */
export function adaptWorkspaceList(rawList) {
  if (!Array.isArray(rawList)) return [];
  return rawList.map(adaptWorkspace).filter(Boolean);
}

/**
 * Extracts the list from various backend response shapes.
 *
 * @param {object|Array} data — API response data
 * @returns {Array}
 */
export function extractWorkspaceList(data) {
  if (Array.isArray(data)) return data;
  return data?.list ?? data?.results ?? data?.workspaces ?? [];
}
